const publications = [
  {
    citation:
      "Rose, S. P., Habgood, M. P. J., & Jay, T. (2020). Designing a Programming Game to Improve Children’s Procedural Abstraction Skills in Scratch. Journal of Educational Computing Research, 0(0), 140.",
    link: "https://journals.sagepub.com/doi/10.1177/0735633120932871",
  },
  {
    citation:
      "Rose, S. P., Habgood, M. P. J., & Jay, T. (2019). Using Pirate Plunder to Develop Children’s Abstraction Skills in Scratch. In CHI 2019 Conference on Human Factors in Computing Systems, 1-6.",
    link: "https://dl.acm.org/doi/10.1145/3290607.3312871",
  },
  {
    citation:
      "Rose, S. P., Habgood, M. P. J., & Jay, T. (2018) Pirate Plunder : Game-Based Computational Thinking Using Scratch Blocks, In Proceedings of the 12th European Conference for Game Based Learning, 556–564.",
    link:
      "https://www.researchgate.net/publication/328198750_Pirate_Plunder_Game-Based_Computational_Thinking_Using_Scratch_Blocks",
  },
  {
    citation:
      "Rose, S. P., Habgood, M. P. J., & Jay, T. (2017). An Exploration of the Role of Visual Programming Tools in the Development of Young Children’s Computational Thinking. Electronic Journal of E-Learning, 15(4), 297–309.",
    link:
      "https://www.researchgate.net/publication/319328130_An_Exploration_of_the_Role_of_Visual_Programming_Tools_in_the_Development_of_Young_Children's_Computational_Thinking",
  },
  {
    citation:
      "Rose, S. P. (2016). Bricolage Programming and Problem Solving Ability in Young Children: An Exploratory Study. In Proceedings of the 10th European Conference for Game Based Learning, 914-921.",
    link:
      "https://www.researchgate.net/publication/308748624_Bricolage_Programming_and_Problem_Solving_Ability_in_Young_Children_An_Exploratory_Study",
  },
]

export default publications
